module.exports = __webpack_public_path__ + "static/prototype-ca00879c439f53b00b8c3f958ab637a7.png";